export default __webpack_public_path__ + "static/section-team-1-170ea3d96795e13f8d92f2a0ed466af0.jpg";